import React, { CSSProperties, useContext } from "react";
import { ActionBarConfig } from "common/utils/actionBar";
import { useIsScreenSize } from "../../../hooks/useWindowSize";
import { SideNavWidthContext } from "../../SideNav";
import { ActionBar } from "../ActionBar/ActionBar";
import { useTableRowsSelectionState } from "../Tables/RowSelectionProvider";
import { ActionBarWrapperContainer } from "./__styles__/ActionBarWrapper";

interface ActionBarWrapperProps {
  actionBarConfig: ActionBarConfig;
  refetchTable: () => void;
}

export function ActionBarWrapper({
  actionBarConfig,
  refetchTable,
}: ActionBarWrapperProps) {
  const { state, resetRowSelection } = useTableRowsSelectionState();
  const isDesktop = useIsScreenSize("desktop");
  const { width: sideNavWidth } = useContext(SideNavWidthContext);

  if (state.totalSelected === 0) {
    return null;
  }

  const onSubmit = () => {
    resetRowSelection();
    refetchTable();
  };

  const leftOffset = isDesktop ? sideNavWidth / 2 : 0;

  return (
    <ActionBarWrapperContainer
      hasSidebar={isDesktop}
      style={
        {
          "--left-offset": `${leftOffset}px`,
        } as CSSProperties
      }
    >
      <ActionBar actionBarConfig={actionBarConfig} onSubmit={onSubmit} />
    </ActionBarWrapperContainer>
  );
}
